module.exports = __webpack_public_path__ + "static/media/sampleExcludeSuppressionListDomain.fa71a873.csv";